import React, { useState } from 'react';
import { Button, Card, Tab } from 'react-bootstrap';

import Tabs from '../../../app/components/Tabs';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { Pricing } from '../../components/Pricing/Pricing';
import { PricingEditor } from '../../components/Pricing/PricingEditor';
import {
  CreateUpdatePricingDto,
  GetPricingDto,
  ResponseError,
} from '../../../common/spdCore/autogenerated/spdApiClient';
import { responseErrors } from '../../../common/spdCore/validation/responseErrors';
import { pricingData } from '../../../common/spdCore/contexts/PricingContext';

export const PricingView: React.FC = () => {
  const spd = useSpdCore();
  const [showEditor, setShowEditor] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [pricing, setPricing] = useState<GetPricingDto>();

  const handleAdd = () => {
    setPricing(undefined);
    setShowEditor(true);
  };

  const onRowClick = async (id: string) => {
    const pricingData = await spd.pricing.getById(id);
    setPricing(pricingData);
    setShowEditor(true);
  };

  const handleSave = async (dto: CreateUpdatePricingDto, id?: string) => {
    try {
      dto.prices = dto.prices?.map(price => ({
        ...price,
        price: price.price?.replace(/,/g, '.').replace(/[^0-9.]/g, ''),
      }));
      if (id) {
        await spd.pricing.updateWithPricelist(id, dto);
      } else {
        await spd.pricing.createWithPricelist(dto);
      }
      setShowEditor(false);
      setRefresh(prev => !prev);
      return {
        saved: true,
        errors: [],
      };
    } catch (response) {
      return {
        saved: false,
        errors: await responseErrors(response as ResponseError),
      };
    }
  };
  return (
    <Card>
      <Tabs defaultActiveKey="pricing" id="pricingView" className="mb-3">
        <Tab eventKey="pricing" title="Cenniki" className="m-3">
          <Pricing
            getData={spd.pricing.getAllByPortion}
            getCount={spd.pricing.getAllCount}
            refresh={refresh}
            onRowClick={onRowClick}
          />
          <Button
            variant="outline-primary"
            onClick={handleAdd}
            className="mt-3"
          >
            Nowy cennik
          </Button>
          <PricingEditor
            pricing={pricingData(pricing)}
            onCompleted={handleSave}
            show={showEditor}
            handleClose={() => setShowEditor(false)}
            id={pricing?.id}
          />
        </Tab>
      </Tabs>
    </Card>
  );
};
